import { TinySlider } from "../../global/global-custom";
import { getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { apiCaching } from "../config/cachingConfig";
import { attachEventListenerForClaim, getOfferTeaserPath } from "../util/coupons-event-handling";
import { getPageSettings } from "../util/pageSettings";

export class OffersTeaser {
    private static instance: OffersTeaser;

    constructor() {
        this.init();
       this.attachEventListnerForOfferTeaser();
    }
    static getInstance(): OffersTeaser {
        if (!OffersTeaser.instance) {
            OffersTeaser.instance = new OffersTeaser();
        }
        return OffersTeaser.instance;
    }

    init() {
        const dbaName: string | null = localStorage.getItem('dbaName');
        const webId: string | null = localStorage.getItem('weblocationId');
        if (webId && dbaName && !window.location.href.includes(dbaName)) {
            this.fetchTeaserInfo();
        }
    }

    async fetchTeaserInfo() {
        // Check if the element exists and has a value
        if (this.hasTeaserComponent()) {
            const urlSiteConfig = await getOfferTeaserPath();
            try {
                if (urlSiteConfig != null) {
                    let result = await getCachedAPIResponse(urlSiteConfig, apiCaching.OfferTeaser, false);
                    if (!result || result.status === 404 || Object.keys(result).length === 0) {
                        // Remove the entire section if result is empty or 404 status
                        const section = document.querySelector('.offers-block-section');
                        if (section) {
                            section.remove();  // Removes the section from the DOM
                        }
                    } else {
                        // Replace the content of the section with class 'offers-block-section' with the fetched data
                        this.replaceSectionContent(result.SpecialOfferMarkup, '.offers-block-wrapper');
                        const offersliderElement = new TinySlider();
                        //link inside the offer teaser
                        const linkElement = document.querySelector('.offers-header .header-cta a');
                        if (result?.LocalSpecialOfferPagePath) {
                            // href to be replaced with result.LocalSpecialOfferPagePath
                            if (linkElement instanceof HTMLAnchorElement) {
                                linkElement.href = result.LocalSpecialOfferPagePath;
                            }
                        }
                    }
                    //attach event for localised header - national header
                    this.attachEventListnerForOfferTeaser();
                }
                else {
                    const section = document.querySelector('.offers-block-section');
                        if (section) {
                            section.remove();  // Removes the section from the DOM
                        } 
                }
            }
            catch {
                const section = document.querySelector('.offers-block-section');
                        if (section) {
                            section.remove();  // Removes the section from the DOM
                        } 
            }
        }


    }
    private hasTeaserComponent(): boolean {
        const str = getPageSettings('specialoffersteasercomponent');
        const pageScope = getPageSettings('pagescope');
        return (str === 'true' || str === true) && pageScope === 'national';
    }

    private replaceSectionContent(responseData: string, targetSelector: string): void {
        const targetElement = document.querySelector(targetSelector);

    if (targetElement) {
        targetElement.innerHTML = responseData;
    }
    }


     attachEventListnerForOfferTeaser() {
        attachEventListenerForClaim('.offers-block-section.dynamic-offer-teaser-component', '.offers-block-item a.secondary-btn','li.offers-block-item',{
            titleSelector: '.offers-block-details .block-offer',
            descriptionSelector: '.offers-block-details .offers-block-desc',
            expirySelector: '.offers-block-main .offers-block-expire',
            disclaimerSelector: '.offers-block-disclaimer',
            couponCodeInputSelector: '#nblyFeaturedOfferTeaserCpnCode'
        }); 
        
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const specialOffers = document
        .querySelector(".offers-block-section.dynamic-offer-teaser-component")
        ?.querySelector(".offers-block-wrapper .offers-block-list") as HTMLElement | null;
    if (specialOffers && !(globalThis as any).__OffersTeaserLoaded) {
        (globalThis as any).__OffersTeaserLoaded = true;
        OffersTeaser.getInstance()
    }
});